<template>
    <div class="content-nav-wrapper">
        <span class="content-nav-outer" v-for="title in titles" :key="title.title">
            <span class="content-nav link" v-if="title.routeName" >
                <router-link class="link" :to="{name: title.routeName}">{{title.title}}</router-link>
            </span>
            <span class="content-nav text" v-else>
                {{title.title}}
            </span>
            <span class="caret"><b-icon icon="caret-right-fill"></b-icon></span>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        titles: {
            required: true,
            type: Array,
        },
    },
};
</script>

<style scoped>
    .content-nav-wrapper{
        margin: 10px 40px 10px 0;
        text-transform: uppercase;
        display: flex;
    }
    .content-nav-outer{
        display: flex;
    }
    .link {
        color: black;
    }
    .link:hover {
        text-decoration: none;
    }
    .content-nav-outer:last-child .caret {
        display: none;
    }
    .caret {
        font-size: small;
        line-height: 14px;
        padding: 5px;
    }
</style>
